import { jwtDecode } from 'jwt-decode';
import { getDecryptedToken } from '../services/tokenStorage';

interface UserInfo {
  email?: string;
  username?: string;
  groups?: string[];
}

export const getUserInfo = (): UserInfo | null => {
  const idToken = getDecryptedToken('idToken');
  if (!idToken) return null;

  try {
    const decoded = jwtDecode<any>(idToken);
    return {
      email: decoded.email,
      username: decoded['cognito:username'],
      groups: decoded['cognito:groups'] || [],
    };
  } catch (err) {
    console.error('Failed to decode ID token:', err);
    return null;
  }
};
